import { render, staticRenderFns } from "./ShowInfosButton.vue?vue&type=template&id=207b2bc4&"
import script from "./ShowInfosButton.vue?vue&type=script&lang=js&"
export * from "./ShowInfosButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports